import { loadGroups } from 'components/Presets/sources/presets';

import { useQuery } from '@gogame/query';

import { groups } from './queryKeyFactory';

export const useLoadGroups = (params) => {
  return useQuery(groups(params), (_, { signal }) =>
    loadGroups(params, { signal })
  );
};
